<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
       <v-row>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-skeleton-loader type="table"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-skeleton-loader type="table"></v-skeleton-loader>
          </v-col>
       </v-row>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        <v-row>
          <v-col cols="12">
            <div class="text-h2 text-primary mb-0">
              Relatórios / Resumo Comercial
            </div>
          </v-col>
          <v-col cols="11" class="pt-0">
            <VueCtkDateTimePicker
              v-on:callback="changeDates"
              v-model="data_entrada"
              class="date-picker"
              locale="pt-BR"
              :no-header="true"
              :no-value-to-custom-elem="true"
              :overlay="true"
              :range="true"
              :formatted="'L'"
              :format="'YYYY-MM-DD'"
              color="#EC6521"
              :dark="$vuetify.theme.dark"
              button-color="#EC6521"
              :custom-shortcuts="labels"
              :no-button="true"
              :noClearButton="true"
              :auto-close="true"
              :loading="loadingSearch"
              :disabled="loadingSearch"
              :submit="retornoData()"
            >
              <v-btn class="px-2 py-1 search_data" elevation="0" v-ripple="{ class: `success--text` }">
                <b class="text text-primary">
                  Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                </b>
              </v-btn>
            </VueCtkDateTimePicker>
          </v-col>
          <v-col cols="1" class="pt-0 text-center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit mt-1" v-bind="attrs" v-on="on" @click="print()">
                  <v-icon large color="primary">
                    print
                  </v-icon>
                </v-btn>
              </template>
              <span>Imprimir relatório</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <div id="print" v-if="dados">
        <div class="impressao__header">
          <img v-if="!user.logo_sistema" class="impressao__logo" src="@assets/img/logo.png" alt="SolarMaker">
          <img v-else class="impressao__logo" :src="user.logo_sistema" alt="Logo sistema">
          <p>Relatório de Resumo Comercial</p>
          <span class="impressao__periodo"><br>Período: {{ $root.Formatter.formatDate(de, 'L')}} até {{$root.Formatter.formatDate(ate, 'L') }}</span>
        </div>
        <div class="mb-3">
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="dados.total_periodo">
              <v-simple-table class="base_table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Item
                      </th>
                      <th class="text-center">
                        Quantidade durante o período
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left">
                        Clientes novos
                      </td>
                      <td class="text-center">{{dados.total_periodo.total_clientes}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        Usinas instaladas
                      </td>
                      <td class="text-center">{{dados.total_periodo.total_usinas}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        Chamados realizados
                      </td>
                      <td class="text-center">{{dados.total_periodo.total_chamados}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        Acessos ao APP
                      </td>
                      <td class="text-center">{{dados.total_periodo.total_acesso_app}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        Investido
                      </td>
                      <td class="text-center">{{dados.total_periodo.total_investido}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        Economia
                      </td>
                      <td class="text-center">{{dados.total_periodo.total_economizado}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="dados.total">
              <v-simple-table class="base_table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Item
                      </th>
                      <th class="text-center">
                        Total em {{formatDateFront(ate, 'LL') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left">
                        Total de clientes
                      </td>
                      <td class="text-center">{{dados.total.total_clientes}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        Total de usinas
                      </td>
                      <td class="text-center">{{dados.total.total_usinas}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        Total de chamados
                      </td>
                      <td class="text-center">{{dados.total.total_chamados}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        Total de acessos ao APP
                      </td>
                      <td class="text-center">{{dados.total.total_acesso_app}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        Total investido
                      </td>
                      <td class="text-center">{{dados.total.total_investido}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        Total economizado
                      </td>
                      <td class="text-center">{{dados.total.total_economizado}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </div>
      </div>
      <div v-else>
        Nenhum dado encontrado.
      </div>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import Printd from 'printd'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
  components: {
    VueCtkDateTimePicker
  },
  data () {
    return {
      user: null,
      datetime: new Date(),
      loading: true,
      loadingSearch: false,
      dados: [
        {
          nome: ''
        }
      ],
      de: moment().startOf('month').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ]
    }
  },
  methods: {
    async print () {
      const d = new Printd()
      let styles = [
        `
          body {
            overflow: hidden;
            font-family: "Arial", sans-serif !important;
          }
          p, strong, b, small, span, q, i, td {
            color: #000!important;
            font-size: .85rem!important;
            line-height: .9rem!important;
            word-break: keep-all!important;
          }
          .v-application {
            font-family: "Arial", sans-serif !important;
          }
        `,
        `
          .impressao__header {
            width: 100%;
            text-align: center;
            color: #000;
          }
          .impressao__header p {
            margin-top: 1em;
            font-size: 14px;
            font-weight: bold;
          }
          .impressao__header span {
            color: red;
            text-align: left;
            margin-top: 2em;
            font-size: 13px;
            font-weight: bold;
          }
          .impressao__logo {
            max-width: 20%;
            color: #000!important;
          }
          .impressao__footer {
            bottom: 0;
            position: fixed;
            width: 100%;
            display: none;
          }
          .impressao__footer_text {
            text-align: center;
            color: #d0d0d0;
            font-size: 11px;
            padding-top: 5px;
          }
          .impressao__footer_hr {
            margin-bottom: 10px;
          }
          .impressao__break {
            page-break-after: always;
          }
          .impressao__footer, .impressao__footer-space {
            height: 2em;
          }
          .impressao__periodo {
            font-size: 12px!important;
          }
          #print .text-h3 {
            font-weight: bold;
            font-size: 13px;
            margin-top: 3em;
          }
          @media screen {
            .impressao__footer {
              display: none;
            }
          }
          @media print {
            thead {display: table-header-group;}
            tfoot {display: table-footer-group;}
            button {display: none;}
            body {margin: 0;}
            * {
              color: #000!important;
            }
            .v-data-table th {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              min-width: 4em;
            }
            .v-data-table td {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              max-width: 20em;
            }
            .v-data-table .text-center {
              text-align: center;
            }
            p {
              widows: 3;
            }

            .impressao__footer {
              display: block;
            }
            .impressao__header {
              display: block;
              width: 100%;
              color: #000!important;
            }
          }
          @page {
            size: A4 !important;
            margin: 12mm;
          }
        `,
        'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
        'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
      ]

      let documento = document.getElementById('print')
      await d.print(documento, styles)
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.applyFilter()
        }
      }
    },
    applyFilter () {
      this.loading = true
      let query = Object.assign({},
        this.de ? { de: this.de } : '',
        this.ate ? { ate: this.ate } : ''
      )
      this.$router.replace({name: 'RelatoriosResumoComercial', query: query}).catch(() => {})
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      this.loadFunctions(this.de, this.ate)
    },
    loadFunctions (inicio, fim) {
      let endpoint = inicio ? '?de=' + inicio : '?de='
      endpoint += fim ? '&ate=' + fim : '&ate='
      this.getFaturas(endpoint)
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.de) this.de = filters.de
      if (filters.ate) this.ate = filters.ate
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      this.loadFunctions(this.de, this.ate)
    },
    async getFaturas (endpoint) {
      this.loading = true
      await Api.get('relatorios/resumo-comercial' + endpoint)
        .then(res => {
          this.dados = res.data
          console.log('Resumo comercial ==>', res.data)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os resumos comerciais!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item_lista {
  border: 1px $primary solid;
  border-left-width: 10px;
  height: 100%;
  padding: 15px;
  .text-h3 {
    margin-bottom: 25px;
    position: relative;
    &:before {
      background: $primary;
      bottom: -10px;
      content: '';
      height: 1px;
      left: -15px;
      position: absolute;
      width: calc(100% + 30px);
    }
  }
  @media (max-width: 767px){}
}
.impressao__header, .impressao__periodo {
  width: 100%;
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/pages/relatorios/comercial/ResumoComercial.vue